var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollBody",staticClass:"custom-list",on:{"mouseenter":_vm.mouseenterFunc,"mouseleave":_vm.mouseleaveFunc,"mousewheel":_vm.mousewheelFunc}},[_c('div',{ref:"listBody",staticClass:"list-body",class:{
      'list-body2': _vm.isHorizontal
    },style:({ transform: _vm.getScrollDistance() })},[_vm._t("default")],2),_vm._v(" "),(_vm.isCanScroll)?_c('div',{ref:"tBody",staticClass:"list-body",class:{
      'list-body2': _vm.isHorizontal
    },style:({ transform: _vm.getScrollDistance() })},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad36ecc6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin/index.vue
// module id = 9
// module chunks = 0